"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versionWatcher = versionWatcher;

var _effects = require("redux-saga/effects");

var _apiRequest = require("../api/apiRequest");

var actions = _interopRequireWildcard(require("./actions"));

var types = _interopRequireWildcard(require("./types"));

var versionAction = _interopRequireWildcard(require("../../version/actions"));

var _selectors = require("../../version/selectors");

var _actions3 = require("../../app/updateFlow/actions");

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(versionWorker),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(versionWatcher);

function versionWorker() {
  var version, newVersion, isNewVersion;
  return regeneratorRuntime.wrap(function versionWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.put)(actions.start());

        case 3:
          _context.next = 5;
          return (0, _effects.select)(_selectors.getVersion);

        case 5:
          version = _context.sent;
          _context.next = 8;
          return (0, _effects.call)(_apiRequest.apiRequest, "version", "GET", {
            auth: false
          });

        case 8:
          newVersion = _context.sent;
          isNewVersion = version.id !== undefined && !_lodash["default"].isEqual(version, newVersion);
          _context.next = 12;
          return (0, _effects.put)(versionAction.set(newVersion));

        case 12:
          if (!isNewVersion) {
            _context.next = 15;
            break;
          }

          _context.next = 15;
          return (0, _effects.put)((0, _actions3.saga)(newVersion));

        case 15:
          _context.next = 17;
          return (0, _effects.put)(actions.success());

        case 17:
          _context.next = 24;
          break;

        case 19:
          _context.prev = 19;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
          _context.next = 24;
          return (0, _effects.put)(actions.failure());

        case 24:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 19]]);
}

function versionWatcher() {
  return regeneratorRuntime.wrap(function versionWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(types.SAGA, versionWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}